import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { browserBuild, useReleases } from "@/api/releases";
import { Button } from "@/components/ui/Button";
export function SystemInformation({
  showHistoryLink = true,
}: {
  showHistoryLink?: boolean;
}) {
  const { t, i18n } = useTranslation();
  const q = useReleases();
  const date = (at?: number) =>
    at ? new Date(at).toLocaleString(i18n.language) : t("releases.unknownDate");
  return (
    <section className="rounded-md border border-line bg-surface p-4">
      <h2 className="text-base font-semibold">{t("releases.system")}</h2>
      <dl className="mt-4 grid gap-4 sm:grid-cols-2">
        <div>
          <dt className="text-xs text-ink-faint">
            {t("releases.browserVersion")}
          </dt>
          <dd className="mt-1 font-mono tabular">
            {t("common.webVersion", { version: browserBuild.version })}
          </dd>
          <p className="mt-1 text-xs text-ink-soft">
            {browserBuild.mode === "development"
              ? t("releases.devHint")
              : browserBuild.mode === "untracked"
                ? t("releases.untrackedHint")
                : date(q.data?.loaded?.deployedAt)}
          </p>
        </div>
        <div>
          <dt className="text-xs text-ink-faint">{t("releases.latest")}</dt>
          <dd className="mt-1 font-mono tabular">
            {q.data?.latest
              ? t("common.webVersion", { version: q.data.latest.version })
              : "—"}
          </dd>
          <p className="mt-1 text-xs text-ink-soft">
            {date(q.data?.latest?.deployedAt)}
          </p>
        </div>
      </dl>
      {q.error && (
        <div role="alert" className="mt-3 text-xs text-danger">
          {t("releases.loadError")}{" "}
          <Button size="sm" variant="ghost" onClick={() => q.refetch()}>
            {t("common.retry")}
          </Button>
        </div>
      )}
      {showHistoryLink && (
        <Link
          className="mt-4 inline-block text-sm text-brand underline"
          to="/releases"
        >
          {t("releases.viewHistory")}
        </Link>
      )}
    </section>
  );
}
